export default "__VITE_PUBLIC_ASSET__c1a8b1bf__"